import { createSelector } from 'reselect'

export const getRemoteOrderTotal = (state) => {
  return state?.orderTotalRemote
}
